import { Injectable } from "@angular/core";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { AppService } from "./app.service";
import { getUser } from "@edp-store/selectors/user.selectors";
import { EdpUser } from "@edp-models/user.model";
import { Contract } from "@edp-components/edp-contract";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { MedalliaTracking } from "@edp-models/medallia-tracking.model";
import { environment } from "@edp-environments/environment";

@Injectable({
    providedIn: "root",
})
export class MeddaliaTrackingService {
    contract: Contract;
    user: EdpUser;

    constructor(public store: Store<IAppState>, public appService: AppService) {
        this.store.pipe(select(getUser)).subscribe(user => {
            if (user) {
                this.user = user;
            }
        });
        this.store.pipe(select(getContract)).subscribe(contract => {
            if (contract) {
                this.contract = contract;
            }
        });
    }

    public setMedalliaTracking(operationtype: string): void {
        const medalliaTracking = new MedalliaTracking();
        medalliaTracking.operationtype = operationtype;
        medalliaTracking.userId = this.user.uid;
        medalliaTracking.combinedValue = `${medalliaTracking.operationtype}|${medalliaTracking.userId}`;
        medalliaTracking.source = environment.isApp ? "app" : "web";
        medalliaTracking.segment = "B2C";
        medalliaTracking.Partnernumber = this.user.partnerNumber.toString();
        if (this.contract.HasE && !this.contract.HasG) {
            medalliaTracking.Typecontract = "E";
        } else if (!this.contract.HasE && this.contract.HasG) {
            medalliaTracking.Typecontract = "G";
        } else if (this.contract.HasE && this.contract.HasG) {
            medalliaTracking.Typecontract = "E/G";
        }
        medalliaTracking.FlagPack = !!this.contract.HasPack ? "1" : "0";
        medalliaTracking.FlagCC = !!this.contract.HasContaCerta ? "1" : "0";
        medalliaTracking.FlagMobility = !!this.contract.HasM ? "1" : "0";
        medalliaTracking.FlagSolar = this.contract.hasSolar() ? "1" : "0";
        medalliaTracking.FlagFE = !!this.contract.HasElectronicInvoice ? "1" : "0";
        medalliaTracking.FlagDD = this.contract.HasDirectDebit ? "1" : "0";
        this.appService.setMedalliaTracking(medalliaTracking);
    }
}
